const env = {
    production: false,
    api: {
        host: 'https://api-retcercano-qa.ripley.com.pe/auth',
        x_api_key: '0oevDLNwix9aCfGR73BVF1E1DOxtAKqKaowG7Tkg',
    },
    recaptcha: {
        webKey: "6LcTr_YcAAAAAKnsseyQVSnkgpQM5FnRKgkG52bK"
    }
  }
  
  export default env;